namespace Matrix.Administration {
    export interface UserForm {
        Username: Serenity.StringEditor;
        Email: Serenity.EmailAddressEditor;
        FullName: Serenity.StringEditor;
        Password: Serenity.PasswordEditor;
        PasswordConfirm: Serenity.PasswordEditor;
        RoleNames: Serenity.LookupEditor;
        Groups: Serenity.LookupEditor;
        GroupRoles: Serenity.LookupEditor;
        ProfileImage: Serenity.ImageUploadEditor;
        IsActive: Serenity.BooleanEditor;
    }

    export class UserForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.User';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UserForm.init)  {
                UserForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EmailAddressEditor;
                var w2 = s.PasswordEditor;
                var w3 = s.LookupEditor;
                var w4 = s.ImageUploadEditor;
                var w5 = s.BooleanEditor;

                Q.initFormType(UserForm, [
                    'Username', w0,
                    'Email', w1,
                    'FullName', w0,
                    'Password', w2,
                    'PasswordConfirm', w2,
                    'RoleNames', w3,
                    'Groups', w3,
                    'GroupRoles', w3,
                    'ProfileImage', w4,
                    'IsActive', w5
                ]);
            }
        }
    }
}
